// material-ui
import { Typography, Button, Stack, Input, Alert, Table, TableBody, TableCell, TableRow, TableHead, Select, MenuItem, FormHelperText, Skeleton, Box } from '@mui/material';
import Pagination from 'components/@extended/Pagination';

// project import
import MainCard from 'components/MainCard';
import { Notice } from 'components/Notice';
import CsvUploader from 'components/Uploaders/CsvUploader';
import { isShopifyApp } from 'context/UserAuthContext';
import React from 'react';
import { getRequest } from 'utils/apiRequest';


// ==============================|| SAMPLE PAGE ||============================== //

const OrdersLoading = () => {
    return (<>
        {[...Array(50)].map((v, i) => {
            return (
                <TableRow key={i}>
                    <TableCell width={200}><Skeleton variant="text" width="40%" /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" /></TableCell>
                </TableRow>
            )
        })}
    </>)
}
const Orders = () => {
    const [accountOrders, setAccountOrders] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [pagination, setPagination] = React.useState({
        current: 1,
        total: 1,
    });
    React.useEffect(() => {
        getOrders();
    }, []);
    const getOrders = (page = 1) => {
        setLoading(true);
        getRequest('/account/orders?page=' + page).then((d) => {
            if(d && d.data){
                setAccountOrders(d.data);
                setPagination({
                    current: d.current_page,
                    total: d.last_page,
                })
            }
        }).finally(()=>{
            setLoading(false);
        })
    }
    const setPage = (p) => {
        getOrders(p);
    };
    return (
        <MainCard title="Orders" secondary={!isShopifyApp() && <CsvUploader buttonText="Upload CSV" type="orders" />}>
            {loading || accountOrders.length > 0 ? (
                <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Order Number</TableCell>
                        <TableCell>Nearest Warehouse</TableCell>
                        <TableCell>Order Date</TableCell>
                        <TableCell>Deliver By</TableCell>
                        <TableCell>Billing</TableCell>
                        <TableCell>Shipping</TableCell>
                        <TableCell># Items</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {loading ? <OrdersLoading /> : (<>
                    {accountOrders.map((o, i) => {
                        let lowestFufillmentDate = null;
                        if(o.line_items && o.line_items.length > 0){
                            const sortedLineItems = o.line_items.sort((a, b)=> a.estimated_delivery_date - b.estimated_delivery_date);
                            if(sortedLineItems[0]){
                                lowestFufillmentDate = new Intl.DateTimeFormat('en-US').format(new Date(sortedLineItems[0].estimated_delivery_date));
                            }
                        }
                        return (o.id ? (<TableRow key={i}>
                            <TableCell>
                                <Box sx={{width: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                {o.order_number}
                                </Box>
                            </TableCell>
                            <TableCell>
                                {o.nearest_warehouse && o.nearest_warehouse.name}
                            </TableCell>
                            <TableCell>
                                {new Intl.DateTimeFormat('en-US').format(new Date(o.created_at))}
                            </TableCell>
                            <TableCell>
                                {lowestFufillmentDate}
                            </TableCell>
                            <TableCell>
                                {o.billing && o.billing.address && o.billing.address.city ? (<>
                                {o.billing.address.city + (o.billing.address.city  ? ', ' : '')} {o.billing.address.state} {o.billing.address.zip}<br /></>) : <></>}
                            </TableCell>
                            <TableCell>
                                {o.shipping && o.shipping.address && o.shipping.address.city ? (<>
                                {o.shipping.address.city + (o.shipping.address.city  ? ', ' : '')} {o.shipping.address.state} {o.shipping.address.zip}<br /></>) : <></>}
                            </TableCell>
                            {/* <TableCell>
                                {new Intl.NumberFormat('en-US', { style: 'currency', currency: o.currency_code }).format(o.amount_total / 100)}
                            </TableCell> */}
                            <TableCell sx={{textAlign: 'center'}}>
                                {o.line_items && o.line_items.length}
                            </TableCell>
                        </TableRow>) : null
                        )
                    })}
                    </>) }
                </TableBody>
            </Table>
            <Pagination
                count={pagination.total}
                page={pagination.current}
                setPage={(p) => setPage(p)}
            />
            </>) : (
            <Notice>No orders yet. This data will populate as orders are placed on your website. If you have not integrated with your website, view our <a href={process.env.REACT_APP_DOCS_URL} target="_blank">documentation</a> to get started.</Notice>
        )}
        </MainCard>);
}

export default Orders;
